module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/dog-water-park-581.44e273451ed75f86.png"+" 581w",
        images: [{path: "https://static.sniffspot.com/packs/img/dog-water-park-581.44e273451ed75f86.png",width: 581,height: 400}],
        src: "https://static.sniffspot.com/packs/img/dog-water-park-581.44e273451ed75f86.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/dog-water-park-581.44e273451ed75f86.png"},
        
        width: 581,
        height: 400
      }